// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.door-keys {
  position: fixed;
  inset: 0;
  z-index: 9990;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.45);
}
.door-keys__panel {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: ink-enter 0.16s ease-out;
  width: 460px;
  max-height: 80vh;
  overflow-y: auto;
  padding: 20px 22px 18px;
}
.door-keys__panel * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .door-keys__panel {
    animation: none;
  }
}
.door-keys__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.door-keys__title {
  margin: 0;
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 24px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
}
.door-keys__sub {
  margin: 4px 0 14px;
  font-size: 13px;
  color: #8d8a82;
}
.door-keys__h3 {
  margin: 16px 0 8px;
  font-size: 14px;
  font-weight: 700;
  color: #aeaba2;
}
.door-keys__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
  color: #aeaba2;
}
.door-keys__field input {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
}
.door-keys__field input:focus {
  outline: none;
  border-color: var(--gold-main);
}
.door-keys__field input::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.door-keys__list {
  margin: 0;
  padding: 0;
  list-style: none;
  max-height: 220px;
  overflow-y: auto;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}
.door-keys__list::-webkit-scrollbar {
  width: 6px;
}
.door-keys__list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.door-keys__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.door-keys__name {
  font-size: 15px;
}
.door-keys__add {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}
.door-keys__add input {
  flex: 1 1 auto;
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
}
.door-keys__add input:focus {
  outline: none;
  border-color: var(--gold-main);
}
.door-keys__add input::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.door-keys__foot {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 18px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.door-keys__warn {
  flex: 1 1 auto;
  font-size: 12px;
  color: #aeaba2;
}
.door-keys__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  padding: 5px 10px;
  font-size: 13px;
  cursor: pointer;
}
.door-keys__btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.door-keys__btn:active:not(:disabled) {
  transform: translateY(1px);
}
.door-keys__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.door-keys__btn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.door-keys__btn--primary {
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.door-keys__btn--primary:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}
.door-keys__btn--danger {
  color: #d9786d;
  background: transparent;
  border-color: rgba(217, 120, 109, 0.45);
}
.door-keys__btn--danger:hover:not(:disabled) {
  background: rgba(217, 120, 109, 0.14);
  border-color: #d9786d;
}
.door-keys__btn--quiet {
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
}
.door-keys__btn--quiet:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}
.door-keys__btn:disabled {
  opacity: 0.45;
  cursor: default;
}
.door-keys__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
  padding: 5px 10px;
  font-size: 13px;
  cursor: pointer;
}
.door-keys__close:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.door-keys__close:active:not(:disabled) {
  transform: translateY(1px);
}
.door-keys__close:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.door-keys__close:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.door-keys__close:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/components/DoorKeys/DoorKeys.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AANA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yDDoBU;ECnBV,cDUK;ECTL,+BAAA;AAQF;AANE;EDmBA,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EAiIA,mCAAA;EC7JE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AAcJ;ADCE;EAAI,sBAAA;ACEN;AD2IE;EClKA;IDkK0C,eAAA;ECvI1C;AACF;AAnBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAqBJ;AAlBE;EACE,SAAA;ED0BF,kDA3BW;EA4BX,gBAAA;EACA,eC3BqB;ED4BrB,iBAAA;EACA,sBAAA;EACA,cAxCK;ACmCP;AAtBE;EACE,kBAAA;EACA,eAAA;EACA,cDdK;ACsCT;AArBE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDtBK;AC6CT;AApBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,cD9BK;ACoDT;AApBI;EDmFF,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;AC5DF;AD8DE;EAAU,aAAA;EAAe,8BAAA;AC1D3B;AD2DE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACpD1G;AAvCE;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EDuGF,gBAAA;EACA,qBAAA;EACA,qDAAA;AC7DF;AD+DE;EAAuB,UAAA;AC5DzB;AD6DE;EAA6B,oCAAA;EAAsC,kBAAA;ACzDrE;AA/CE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,kDAAA;AAiDJ;AA9CE;EAAU,eAAA;AAiDZ;AA/CE;EACE,aAAA;EACA,QAAA;EACA,gBAAA;AAiDJ;AA/CI;EAAQ,cAAA;EDwDV,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ACLF;ADOE;EAAU,aAAA;EAAe,8BAAA;ACH3B;ADIE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACG1G;AAnEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,+CAAA;AAqEJ;AAlEE;EACE,cAAA;EACA,eAAA;EACA,cD1EK;AC8IT;AAjEE;EDfA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAiCA,iBAAA;EACA,eAAA;EC/BE,eAAA;AAmFJ;ADpFE;EAAyB,qCAAA;EAAuC,8BAAA;ACwFlE;ADvFE;EAA0B,0BAAA;AC0F5B;ADzFE;EAAa,YAAA;EAAc,mBAAA;AC6F7B;AD5FE;EAAkB,oCAAA;EAAsC,mBAAA;ACgG1D;AAhGI;EDIF,cAjFU;EAkFV,4BAAA;EACA,8BAAA;AC+FF;AD7FE;EAAyB,6BAAA;EAA+B,+BAAA;ACiG1D;AAxGI;EDWF,cA5FO;EA6FP,uBAAA;EACA,uCAAA;ACgGF;AD9FE;EAAyB,qCAAA;EAAuC,qBAhGzD;ACkMT;AAhHI;EDkBF,cArGO;EAsGP,uBAAA;EACA,yBAAA;ACiGF;AD/FE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;ACoGhF;AAxHI;EACE,aAAA;EACA,eAAA;AA0HN;AAtHE;ED9BA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAyBA,cArGO;EAsGP,uBAAA;EACA,yBAAA;EAMA,iBAAA;EACA,eAAA;ECfE,eAAA;AA0IJ;AD3JE;EAAyB,qCAAA;EAAuC,8BAAA;AC+JlE;AD9JE;EAA0B,0BAAA;ACiK5B;ADhKE;EAAa,YAAA;EAAc,mBAAA;ACoK7B;ADnKE;EAAkB,oCAAA;EAAsC,mBAAA;ACuK1D;AD/IE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;ACoJhF","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n// The panel of a verrou: a door locked with keys, with no building behind it.\n.door-keys {\n  position: fixed;\n  inset: 0;\n  z-index: 9990;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: ink.$font-text;\n  color: ink.$text;\n  background: rgba(0, 0, 0, 0.45);\n\n  &__panel {\n    @include ink.panel;\n    @include ink.enter;\n    width: 460px;\n    max-height: 80vh;\n    overflow-y: auto;\n    padding: 20px 22px 18px;\n  }\n\n  &__head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  &__title {\n    margin: 0;\n    @include ink.title(24px);\n  }\n\n  &__sub {\n    margin: 4px 0 14px;\n    font-size: 13px;\n    color: ink.$text-3;\n  }\n\n  &__h3 {\n    margin: 16px 0 8px;\n    font-size: 14px;\n    font-weight: 700;\n    color: ink.$text-2;\n  }\n\n  &__field {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    font-size: 13px;\n    color: ink.$text-2;\n\n    input { @include ink.field; }\n  }\n\n  &__list {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    max-height: 220px;\n    overflow-y: auto;\n    @include ink.scroll;\n  }\n\n  &__row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 6px 4px;\n    border-bottom: 1px solid ink.$line;\n  }\n\n  &__name { font-size: 15px; }\n\n  &__add {\n    display: flex;\n    gap: 8px;\n    margin-top: 12px;\n\n    input { flex: 1 1 auto; @include ink.field; }\n  }\n\n  &__foot {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: 18px;\n    padding-top: 12px;\n    border-top: 1px solid ink.$line;\n  }\n\n  &__warn {\n    flex: 1 1 auto;\n    font-size: 12px;\n    color: ink.$text-2;\n  }\n\n  &__btn {\n    @include ink.button;\n    @include ink.button-sm;\n    cursor: pointer;\n\n    &--primary { @include ink.button-primary; }\n    &--danger { @include ink.button-danger; }\n    &--quiet { @include ink.button-quiet; }\n\n    &:disabled {\n      opacity: 0.45;\n      cursor: default;\n    }\n  }\n\n  &__close {\n    @include ink.button;\n    @include ink.button-quiet;\n    @include ink.button-sm;\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
